import { render, staticRenderFns } from "./CompanyIncorporationActivity.vue?vue&type=template&id=31a62b6c&scoped=true&"
import script from "./CompanyIncorporationActivity.vue?vue&type=script&lang=js&"
export * from "./CompanyIncorporationActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a62b6c",
  null
  
)

export default component.exports